<template>
  <v-layout
    row
    align-center
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <page-title :title="$t('my_points')" />
          <div>
            <v-data-table
              :headers="headers"
              :items="points"
              hide-actions
              class="elevation-1"
            >
              <template
                slot="items"
                slot-scope="props"
              >
                <td>{{ printDate(props.item.created_at) }}</td>
                <td class="text-xs-right">{{ props.item.added }}</td>
                <td class="text-xs-right">{{ props.item.day_to_expired }}</td>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import OrderLine from '~/components/OrderLine'

export default {
  name: 'orders-view',
  metaInfo () {
    return { title: this.$t('orders') }
  },
  components: {
    'page-title': PageTitle,
    'order-line': OrderLine
  },
  data: () => ({
    timer: '',
    headers: [
      {
        text: 'Date',
        align: 'left',
        sortable: false,
        value: 'date'
      },
      { text: 'Points', align: 'right', value: 'added' },
      { text: 'Expire in days', align: 'right', value: 'day_to_expired' }
    ]
  }),
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('member', [
      'points'
    ]),
    subtotalStyle () {
      return {
        textAlign: 'right',
        marginTop: '20px'
      }
    }
  },
  methods: {
    printDate (d) {
      const d2 = moment(d, 'YYYY-MM-DD HH:mm:ss')
      const today = moment()
      const yesterday = moment().subtract(1, 'day')
      if (d2.isSame(today, 'day')) return 'Today ' + d2.format('h:mm A')
      if (d2.isSame(yesterday, 'day')) return 'Yesterday ' + d2.format('h:mm A')
      return d2.format('D/M/YY h:mm A')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/points.vue